<template>
  <transition name="modal_">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  methods: {
    show (e) {
      e.keyCode && e.keyCode == 27 && this.$emit('close')
    }
  },
  created () {
    document.addEventListener('keyup', this.show)
  },
  destroyed () {
    document.removeEventListener('keyup', this.show)
  }
}
</script>

<style lang="css" scoped>
.modal-enter,
.modal-leave-active {
	opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>
